<template>
  <div class="na">
    <div class="info">
      <div class="info__user">
        <div class="info__image">
          <img v-if="headImg" :src="headImg">
          <img v-else src="@/static/image/default-user-portrait.png">
        </div>
        <div class="info__info">
          <div class="info__top">
            <div class="info__name">
              {{ nickName }}
            </div>
            <div class="info__enddate" v-if="expirationDate">{{ expirationDate }} 到期</div>
          </div>
          <div class="info__hint">
            <img src="@/static/image/netease-history-hint.png">
          </div>
        </div>
      </div>
      <div class="info__swiper">
        <Swiper :pagination="true" :modules="[Pagination]">
          <SwiperSlide v-for="(count, i) in subscribeListCount" :key="i">
            <div class="swiper-item" v-for="item in count" :key="item.name" @click="openCouponsDetail(item)">
              <img class="swiper-itemicon" :src="'/images/' + item.icon" alt="">
              <div class="swiper-itemname">{{ item.name }}</div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        券发放情况
      </div>
      <div class="card__subtitle">请至「我的-我的卡券」查看已发放的优惠券</div>
      <div class="card__list">
        <div class="card__header">
          <div>权益月</div>
          <div>发放日</div>
          <div>发放情况</div>
        </div>
        <div class="card__item" :class="{ 'card__item--done': item.grantStatus == 1 }"
          v-for="(item, index) in grantLogs" :key="index">
          <div>{{ item.grantCycle == 1 ? '首次购买' : `第${item.grantCycle}月` }}</div>
          <div>{{ item.grantTime }}</div>
          <div v-if="item.grantStatus == 1"><span>已发放</span></div>
          <div v-else>待发放</div>
        </div>
      </div>
    </div>
    <couponsDetail ref="couponsDetailRef"></couponsDetail>

  </div>
</template>
<script setup>

import * as api from "@/api/otherOrder";
import { ref } from "vue";
import Ditto from '@zeekr-f2e/zeekr-ditto'
import { useRouter } from "vue-router";
import { getCurrentInstance } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import subscribeList from './subscribeList';
import { Toast } from 'vant';
import couponsDetail from './couponsDetail';
const _subscribeList = [...subscribeList]
const subscribeListCount = []
while (_subscribeList.length) {
  subscribeListCount.push(_subscribeList.splice(0, 5))
}

const { proxy } = getCurrentInstance()
const router = useRouter();

const couponsDetailRef = ref(null)

const vipCode = ref("")
const headImg = ref("")
const nickName = ref("")
const isApp = ref(/ZEEKR-APP-(\w+)/.test(navigator.userAgent)) // 是否处于极氪订阅app当中
const expirationDate = ref('') // 过期时间
const grantLogs = ref([]) // 发放记录	

const queryNetEasyJointMember = () => {
  api.queryNetEasyJointMember({
    orderType: 1,	// 订阅增值业务订单订单类型，1-网易严选联合会员购买	
    vipCode: vipCode.value,	// 用户vipCode
  }).then(res => {
    if (res.status === 200 && res.data.code === "0") {
      expirationDate.value = res.data.body.expirationDate
      grantLogs.value = res.data.body.grantLogs
    } else {
      Toast(res.data && res.data.msg || '获取订单信息失败')
    }
  }, () => {
    Toast('获取订单信息失败')
  })
}
const getUserInfo = () => {
  Ditto.registerParams('common_js.getUserInfo').then(res => {
    if (res) {
      if (res.vipCode) {
        vipCode.value = res.vipCode
        headImg.value = res.headImg || ''
        nickName.value = res.nickName || ''
        queryNetEasyJointMember()
      }
    }
  })
}
const openCouponsDetail = (item) => {
  couponsDetailRef.value.open({
    title: item.name,
    content: item.content,
  })
}
if (isApp.value) {
  getUserInfo()
}
</script>
<style scoped>
.na {
  background: #0b0b0b;
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

.info {
  padding: 30px;
  background: url('@/static/image/netease-history-card.png') center top / 100% no-repeat;
  height: 388px;
  border-radius: 8px;
  margin: 30px;
  color: #A2A3A4;
  font-size: 24px;
  position: relative;
  box-sizing: border-box;
}

.card {
  background: #171A1B;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  margin: 30px;

}

.card__title {
  color: #d1d1d1;
  font-weight: bold;
  font-size: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card__title::before,
.card__title::after {
  content: '';
  display: block;
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, #BDC0C4 0%, rgba(189, 192, 196, 0) 100%);
  margin: 0 20px;
}

.card__title::before {
  background: linear-gradient(-90deg, #BDC0C4 0%, rgba(189, 192, 196, 0) 100%);
}

.card__subtitle {
  color: #BDC0C4;
  opacity: 0.6;
  margin-top: 10px;
  font-size: 24px;
  margin-bottom: 30px;
}

.card__header,
.card__item {
  display: flex;
  text-align: center;
  align-items: center;
  font-size: 24px;
  color: #747676;
}

.card__header {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(189, 192, 196, 0.1) 12.35%, rgba(189, 192, 196, 0.1) 87.58%, rgba(255, 255, 255, 0) 100%);
  height: 60px;
  color: #A2A3A4;
}

.card__item {
  height: 36px;
  margin-top: 30px;
}

.card__header>*,
.card__item>* {
  flex-grow: 3;
  width: 1%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card__header>*:first-child,
.card__item>*:first-child {
  flex-grow: 2;
}

.card__header>*:last-child,
.card__item>*:last-child {
  flex-grow: 2;
}

.card__item--done {
  color: #D1D1D1;
}

.card__item--done span {
  display: block;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0.1);
  color: #FF5800;
  border-radius: 20px;
  padding: 0 20px;
}

.info__user {
  display: flex;
  margin-bottom: 40px;
}

.info__image {
  width: 88px;
  height: 88px;
  margin-right: 20px;
  flex-shrink: 0;
}

.info__info {
  flex-grow: 1;
}

.info__image img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.info__top {
  display: flex;
  justify-content: space-between;
}

.info__name {
  color: #D1D1D1;
  font-size: 32px;
}

.info__enddate {
  font-size: 24px;
  color: #747676;
}

.info__hint {
  height: 36px;
  margin-top: 16px;
}

.info__hint img {
  height: 100%;
}

.swiper-itemicon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin: 0 auto 20px;
}

.card__list {
  text-align: left;
}

.swiper-item {
  text-align: center;
  width: 20%;
  display: inline-block;
  color: #A2A3A4;
  font-size: 24px;
  padding: 30px 0;
}

::v-deep .swiper-pagination {
  position: relative;
}

::v-deep .swiper-pagination-bullet {
  background: rgba(255, 255, 255, 0.5);
  height: 4px;
  width: 12px;
  border-radius: 0;
}

::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: rgba(255, 255, 255, 1);
  height: 4px;
  width: 24px;
  border-radius: 0;

}
</style>
